<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">
      <a [routerLink]="'/configuration/ip-rules'">IP rules</a>
    </li>
    <li class="breadcrumb-item" aria-current="page">
      @if (isCreate()) {
        <span class="fs-5 fw-bold mb-0">Add rule</span>
      }
      @if (!isCreate()) {
        <span class="fs-5 fw-bold mb-0">Edit rule</span>
      }
    </li>
  </ol>
</nav>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <div
        class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mb-3">
        <h2 class="fw-bold fs-6 mb-0">Informations</h2>
        <i class="bi bi-person-bounding-box text-primary me-2"></i>
      </div>

      <div class="row mb-3">
        <div class="col-6">
          <label for="name" class="form-label">Name</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-building"></i></span>
            <input type="text" class="form-control" id="name" formControlName="name">
          </div>
        </div>
        <div class="col-6">
          <label for="rule" class="form-label">Type</label>
          <div class="input-group mt-2">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" formControlName="type" id="ip" value="ip">
              <label class="form-check-label" for="ip">IP</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" formControlName="type" id="country" value="country">
              <label class="form-check-label" for="country">Country</label>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-6">
          @if (isTypeIp()) {
            <label for="ip" class="form-label">IP (CIDR notation)</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-hdd-network"></i></span>
              <input type="text" class="form-control" id="ip" formControlName="ip" placeholder="192.168.1.0/32">
            </div>
          }
          @if (!isTypeIp()) {
            <label class="form-label fw-bold small">Country</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-geo-alt"></i></span>
              <app-dropdown-select formControlName="countryCode">
                @for (country of countries; track country) {
                  <app-dropdown-select-option [value]="country.isoCode">
                    <img [ngSrc]="countryService.getFlag(country.isoCode)" [alt]="country.name"
                      class="country-flag"
                      width="24" height="24">
                    {{ country.name }}
                  </app-dropdown-select-option>
                }
              </app-dropdown-select>
            </div>
          }
        </div>
        <div class="col-6">
          <label for="allowed" class="form-label">Access</label>
          <app-input-switch formControlName="allowed" id="allowed" [onLabel]="'Allowed'"
          [offLabel]="'Denied'"></app-input-switch>
        </div>
      </div>

      <div class="col-12 text-end mt-5">
        <button type="submit" class="btn btn-primary fw-bold" [disabled]="!canUpdate()">
          @if (isCreate()) {
            <span>Create</span>
          }
          @if (!isCreate()) {
            <span>Update</span>
          }
        </button>
      </div>
    </form>
  </div>
</div>
